import { useModal } from "@/app/shared/modal-views/use-modal";
import { EndPoints } from "@/Core/Client";
import { httpService } from "@/Core/Client/AxiosConfig";
import {
    UserAssignRoleDto,
    UserAssignRoleSchema,
    UserResponseDto,
} from "@/Dtos/user-dto";

import { Form } from "@/ui/form";
import cn from "@/utils/class-names";
import axios from "axios";
import { useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { PiXBold } from "react-icons/pi";
import { ActionIcon, Button, Input, Title } from "rizzui";
import ReferToSelect from "../shared/refer-to-select";

interface Props {
    editData: UserResponseDto;
    callback?: () => void;
}

export default function AssignRoleForm({ editData, callback }: Props) {
    const { closeModal } = useModal();
    const [message, setMessage] = useState<string>();
    const [reset, setReset] = useState({});
    const [isLoading, setLoading] = useState(false);

    const onSubmit: SubmitHandler<UserAssignRoleDto> = async (data) => {
        setLoading(true);
        console.log("\n data", data);

        try {
            await httpService(EndPoints.user.assignRole).update(
                editData.id!,
                data,
            );
            callback?.();
            setLoading(false);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const { response } = error;
                if (response?.data?.message)
                    setMessage(response?.data?.message);
            }
            setLoading(false);
            return;
        }

        setReset;
        setLoading(false);
        closeModal();
    };

    return (
        <div className="m-auto p-4 md:px-5 md:py-6">
            <div className="mb-6 flex items-center justify-between">
                <Title as="h3" className="text-lg">
                    Assign Role
                </Title>
                <ActionIcon
                    size="sm"
                    variant="text"
                    onClick={() => closeModal()}
                    className="p-0 text-gray-500 hover:!text-gray-900"
                >
                    <PiXBold className="h-[18px] w-[18px]" />
                </ActionIcon>
            </div>

            <Form<UserAssignRoleDto>
                validationSchema={UserAssignRoleSchema}
                onSubmit={onSubmit}
                useFormProps={{
                    defaultValues: {
                        id: editData.id,
                    },
                }}
                className="grid grid-cols-1 gap-5 @container md:grid-cols-2 [&_label]:font-medium"
            >
                {({ register, setValue, watch, formState: { errors } }) => {
                    if (import.meta.env.MODE == "development")
                        console.log("Errors: ", errors, "\n Watch: ", watch());

                    return (
                        <>
                            <input
                                type="hidden"
                                {...register("id")}
                                value={editData?.id}
                            />

                            <Input
                                label="Remarks"
                                {...register("remarks")}
                                className="col-span-full"
                                placeholder="Enter a remarks of event"
                                error={errors.remarks?.message ?? message}
                            />

                            <ReferToSelect
                                multiple
                                title="Role"
                                name="rolesId"
                                register={register}
                                setValue={setValue}
                                defaultValue={editData?.rolesId}
                                className="col-span-full"
                                error={errors.rolesId?.message ?? message}
                                referToEndPoint={EndPoints.role.referTo}
                            />

                            <div
                                className={cn(
                                    "col-span-full grid grid-cols-2 gap-4 pt-5",
                                )}
                            >
                                <Button
                                    variant="outline"
                                    className="w-full @xl:w-auto dark:hover:border-gray-400"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    isLoading={isLoading}
                                    type="submit"
                                    className="hover:gray-700 w-full @xl:w-auto"
                                >
                                    Save
                                </Button>
                            </div>
                        </>
                    );
                }}
            </Form>
        </div>
    );
}
